import { on } from 'helpers/dom'
import throttle from 'lodash.throttle'

class ReadMore extends HTMLElement {
  constructor() {
    super()

    this.label = {
      more: this.dataset.labelMore || 'Read more',
      less: this.dataset.labelLess || 'Read less'
    }
    this.expanded = false
    this.originalContent = this.innerHTML.trim()
    this.indent = Number(this.dataset.indent) || 2
    this.inline = JSON.parse(this.dataset.inline || false)
    this.handleResize = throttle(this.handleResize.bind(this), 500)
  }

  connectedCallback() {
    this.render()
    on('resize', this.handleResize, window)
  }

  handleResize() {
    if (this.expanded) return
    this.render()
  }

  render() {
    this.innerHTML = this.originalContent

    const position = Number(getComputedStyle(this).webkitLineClamp)

    if (this.scrollHeight > this.offsetHeight) {
      if (!this.button) this.createButton()
      this.inline ? this.renderInline(position) : this.insertAdjacentElement('afterend', this.button)
    } else {
      this.button?.remove()
      this.button = null
    }
  }

  createButton() {
    this.button = document.createElement('button')
    this.button.className = 'link'
    this.button.textContent = this.label.more
    on('click', () => this.toggleContent(), this.button)
  }

  renderInline(position) {
    const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, null, false)
    const textNodes = []

    while (walker.nextNode()) textNodes.push(walker.currentNode)
    if (!textNodes.length) return

    const range = document.createRange()
    let lastTop = null
    let lineCount = 1
    const wordPositions = []

    textNodes.forEach((node) => {
      let startOffset = 0
      const words = node.textContent.trim().split(/\s+/)

      words.forEach((word) => {
        range.setStart(node, startOffset)
        range.setEnd(node, startOffset + word.length)

        const rect = range.getBoundingClientRect()

        if (lastTop !== null && rect.top > lastTop) lineCount++
        wordPositions.push({ index: wordPositions.length, node, startOffset, word, line: lineCount })

        lastTop = rect.top
        startOffset += word.length + 1
      })
    })

    const targetWord = wordPositions.find((word) => word.line === position)

    if (!targetWord || targetWord.index + this.indent >= wordPositions.length) return

    const targetIndex = targetWord.index + this.indent
    const allWords = this.originalContent.trim().split(/\s+/)

    this.innerHTML = `${allWords.slice(0, targetIndex).join(' ')}... `
    this.appendChild(this.button)
  }

  toggleContent() {
    this.expanded = !this.expanded
    this.button.textContent = this.expanded ? this.label.less : this.label.more

    if (this.expanded) {
      this.style.display = 'block'
      this.innerHTML = this.originalContent

      if (!this.inline) return
      this.appendChild(this.button)
      this.button.style.display = 'block'
    } else {
      this.button.removeAttribute('style')
      this.removeAttribute('style')
      this.render()
    }
  }
}

customElements.define('read-more', ReadMore)
